import { useEffect, useState } from 'react';
import useApi from './useApi';
import { IMDGCodeClass } from '../types/ProductTypes';
import { useAppSettings } from '../hooks/useAppSettings';

export const useGetIMDGCodeClasses = () => {
    const { state, getApiData } = useApi();
    const { settings: appSettings } = useAppSettings();
    const [imdgCodeClasses, setImdgCodeClasses] = useState<IMDGCodeClass[] | null>(null);

    useEffect(() => {
        const fetchIMDGCodeClasses = async () => {
            try {
                const apiUrl = appSettings?.api;
                if (!apiUrl) {
                    console.warn('[useGetIMDGCodeClasses] API URL not configured in app settings');
                    return;
                }
                await getApiData({ endpoint: `${apiUrl}GetImdgCodeClasses` });
            } catch (error) {
                console.error('[useGetIMDGCodeClasses] Failed to fetch IMDG code classes:', error);
            }
        };

        if (appSettings?.api) {
            fetchIMDGCodeClasses();
        }
    }, [appSettings?.api, getApiData]);

    useEffect(() => {
        if (state.status === 'success' && state.result) {
            // Handle different response formats
            let classes: IMDGCodeClass[] = [];
            if (Array.isArray(state.result)) {
                classes = state.result;
            } else if (state.result.data && Array.isArray(state.result.data)) {
                classes = state.result.data;
            } else if (typeof state.result === 'object') {
                console.warn('[useGetIMDGCodeClasses] Unexpected response format:', state.result);
            }
            setImdgCodeClasses(classes);
        }
    }, [state.status, state.result]);

    return {
        imdgCodeClasses,
        isLoading: state.isLoading,
        error: state.error,
    };
};
